import type { HalfDoughnutSummaryItem } from "components/widgets/HalfDoughnutSummaryWidget"

export const CHART_COLORS = {
  nuveThermostats: "#3b82f6",
  cWireAdapters: "#7c3aed",
} as const

export const CHART_COLORS_SPLIT = {
  thermostatV1: "#43E0F8",
  thermostatV2: "#A855F7",
  cwa: "#6366F1",
  ths: "#3B82F6",
  wls: "#22C55E",
} as const

interface DeviceOrderCounts {
  cwa: number
  thermostatV1: number
  thermostatV2: number
  ths: number
  wls: number
}

interface DeviceOrderFlags {
  thermv2ordering: boolean
  showSensors: boolean
}

export const buildDeviceOrderGroups = (
  { thermv2ordering, showSensors }: DeviceOrderFlags,
  counts: DeviceOrderCounts,
): HalfDoughnutSummaryItem[][] => {
  const thermostatItems = thermv2ordering
    ? [
        { label: "V1 Thermostat", color: CHART_COLORS_SPLIT.thermostatV1, value: counts.thermostatV1 },
        { label: "V2 Thermostat", color: CHART_COLORS_SPLIT.thermostatV2, value: counts.thermostatV2 },
        { label: "CWA", color: CHART_COLORS_SPLIT.cwa, value: counts.cwa },
      ]
    : [
        { label: "Nuve Thermostats", color: CHART_COLORS.nuveThermostats, value: counts.thermostatV1 },
        { label: "C Wire Adapters (CWA)", color: CHART_COLORS.cWireAdapters, value: counts.cwa },
      ]

  const sensorItems = [
    { label: "THS", color: CHART_COLORS_SPLIT.ths, value: counts.ths },
    { label: "WLS", color: CHART_COLORS_SPLIT.wls, value: counts.wls },
  ]

  return showSensors ? [thermostatItems, sensorItems] : [thermostatItems]
}
